module.exports = __webpack_public_path__ + "static/media/icon-mobile.8191b1ab.svg";